import type { GroupAccountDraft, GroupCategoryDraft, User } from "../../lib/types";

export type SelectableCategoryDraft = GroupCategoryDraft & { selected: boolean; is_custom?: boolean };

export type GroupSetupDraft = {
  version: 1;
  name: string;
  baseCurrency: string;
  additionalCurrencies: string[];
  categories: SelectableCategoryDraft[];
  categoriesInitialized: boolean;
  accounts: GroupAccountDraft[];
  accountsInitialized: boolean;
};

export const emptyGroupSetupDraft = (user: User): GroupSetupDraft => ({
  version: 1,
  name: `${user.display_name}'s group`,
  baseCurrency: "EUR",
  additionalCurrencies: [],
  categories: [],
  categoriesInitialized: false,
  accounts: [],
  accountsInitialized: false,
});

export const groupSetupStorageKey = (userId: string) => `financeGroupSetupDraft:v1:${userId}`;

export function loadGroupSetupDraft(user: User): GroupSetupDraft {
  try {
    const parsed = JSON.parse(localStorage.getItem(groupSetupStorageKey(user.id)) || "null") as GroupSetupDraft | null;
    if (parsed?.version === 1) return parsed;
  } catch {
    // A malformed draft should not prevent the user from creating a group.
  }
  return emptyGroupSetupDraft(user);
}

export function newDraftId(prefix: string) {
  return `${prefix}-${crypto.randomUUID()}`;
}
